import PropTypes from 'prop-types';

import NoteStore from '../stores/NoteStore.js';
import SessionStore from '../stores/SessionStore.js'

function select(note) {
  const modifier = SessionStore.getModifier();
  let actualNote = note;

  if (modifier !== 'natural') {
    actualNote += '-' + modifier;
  }

  if (NoteStore.isCurrentNote(actualNote)) {
    SessionStore.recordSuccess(note);
  } else {
    SessionStore.recordFailure(note);
  }

  // Reset to natural
  SessionStore.selectModifier('natural');
}

function className(note) {
  if (SessionStore.isFailure(note)) {
    return 'selection wrong';
  } else if (SessionStore.isSuccess(note)) {
    return 'selection right';
  }
  return 'selection';
}

function NoteButton(props) {
  const {note} = props;

  return (
    <button
      className={className(note)}
      onClick={() => {
        select(note);
      }}>
      {note}
    </button>
  );
}


NoteButton.propTypes = {
  note: PropTypes.string
};

export default NoteButton;
